import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { addIcons } from 'ionicons';
import { informationCircle } from 'ionicons/icons';
import { AppModule } from './app/app.module';
import { environment } from './environments/environment';

if (environment.production) {
  enableProdMode();
}

addIcons({
  'information-circle': informationCircle,
});

platformBrowserDynamic()
  .bootstrapModule(AppModule)
  .catch(err => console.log(err));